<template>

  <v-layout wrap row>

     <v-flex xs12 class="alert">
       <v-alert
           dense
           type="info"
           :value="true"
           color="warning"
       >
         {{ $vuetify.t('$vuetify.UpdateRequestedUserInfo.warningMessage')}}
       </v-alert>
     </v-flex>

    <v-flex xs12 class="user-info">
      <form-with-base-message ref="form"
                              :base-errors="getErrorForField('base')"
                              class="container_form"
                              :success-message="successMessage">
        <v-container fluid>

          <v-layout row wrap>

            <v-flex xs12>
              <v-container ma-0 pa-0 fluid>
                <v-layout row wrap>
                  <v-flex mb-3 xs12
                          class="coloricon--text title-font">
                    {{ $vuetify.t('$vuetify.Account.editUser') }}
                  </v-flex>
                  <v-flex xs12>
                    <v-progress-linear
                        v-if="$apollo.queries.user.loading || loadingUpdateUser"
                        :indeterminate="true"
                        color="blueprimary"></v-progress-linear>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        autocomplete="new-password"
                        v-model="user.firstname"
                        :placeholder="$vuetify.t('$vuetify.Account.namePlaceholder')"
                        background-color="primary"
                        color="secondary"
                        solo
                        :error-messages="getErrorForField('firstname')"
                        @focus="resetErrorForField('firstname')"
                        name="firstname">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        autocomplete="new-password"
                        v-model="user.lastname"
                        :placeholder="$vuetify.t('$vuetify.Account.surnamePlaceholder')"
                        background-color="primary"
                        color="secondary"
                        solo
                        :error-messages="getErrorForField('lastname')"
                        @focus="resetErrorForField('lastname')"
                        name="lastname">
                    </v-text-field>
                  </v-flex>
                  <!--
                  <v-flex xs12>
                      <v-text-field
                              autocomplete="new-password"
                              v-model="user.telephone1"
                              :placeholder="$vuetify.t('$vuetify.Account.phonePlaceholder')"
                              background-color="primary"
                              color="secondary"
                              solo
                              :error-messages="getErrorForField('telephone1')"
                              @focus="resetErrorForField('telephone1')"
                              name="telephone1">
                      </v-text-field>
                  </v-flex>
                  -->
                  <v-flex xs12>
                    <v-text-field
                        autocomplete="new-password"
                        v-model="user.residenceAddress"
                        :placeholder="$vuetify.t('$vuetify.Account.residenceAddressPlaceholder')"
                        background-color="primary"
                        color="secondary"
                        solo
                        :error-messages="getErrorForField('residence_address')"
                        @focus="resetErrorForField('residence_address')"
                        name="residenceAddress">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        autocomplete="new-password"
                        v-model="user.residenceNumber"
                        :placeholder="$vuetify.t('$vuetify.Account.residenceNumberPlaceholder')"
                        background-color="primary"
                        color="secondary"
                        solo
                        :error-messages="getErrorForField('residence_number')"
                        @focus="resetErrorForField('residence_number')"
                        name="residenceNumber">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        autocomplete="new-password"
                        v-model="user.residenceCap"
                        :placeholder="$vuetify.t('$vuetify.Account.residenceCapPlaceholder')"
                        background-color="primary"
                        color="secondary"
                        solo
                        :error-messages="getErrorForField('residence_cap')"
                        @focus="resetErrorForField('residence_cap')"
                        name="residenceCap">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        autocomplete="new-password"
                        v-model="user.residenceCity"
                        :placeholder="$vuetify.t('$vuetify.Account.residenceCityPlaceholder')"
                        background-color="primary"
                        color="secondary"
                        solo
                        :error-messages="getErrorForField('residence_city')"
                        @focus="resetErrorForField('residence_city')"
                        name="residenceCity">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        autocomplete="new-password"
                        v-model="user.residenceDistrict"
                        :placeholder="$vuetify.t('$vuetify.Account.residenceDistrictPlaceholder')"
                        background-color="primary"
                        color="secondary"
                        solo
                        :error-messages="getErrorForField('residence_district')"
                        @focus="resetErrorForField('residence_district')"
                        name="residenceDistrict">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                        :items="getAvaiableCountries()"
                        :placeholder="$vuetify.t('$vuetify.Account.residenceCountryPlaceholder')"
                        color="secondary"
                        background-color="primary"
                        name="residenceCountry"
                        solo
                        :error-messages="getErrorForField('residence_country')"
                        label="Box style"
                        v-model="user.residenceCountry"
                        @focus="resetErrorForField('residence_country')"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        autocomplete="new-password"
                        v-model="user.nationalIdentificationNumber"
                        :placeholder="$vuetify.t('$vuetify.Account.nationalIdentificationNumberPlaceholder')"
                        background-color="primary"
                        color="secondary"
                        solo
                        :error-messages="getErrorForField('national_identification_number')"
                        @focus="resetErrorForField('national_identification_number')"
                        @input="user.nationalIdentificationNumber = user.nationalIdentificationNumber.toUpperCase()"
                        name="nationalIdentificationNumber">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        autocomplete="new-password"
                        v-model="user.badge"
                        :placeholder="$vuetify.t('$vuetify.Account.badgePlaceholder')"
                        background-color="primary"
                        color="secondary"
                        solo
                        :error-messages="getErrorForField('badge')"
                        @focus="resetErrorForField('badge')"
                        name="badge">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        autocomplete="new-password"
                        v-model="user.email"
                        :placeholder="$vuetify.t('$vuetify.Account.emailPlaceholder')"
                        background-color="primary"
                        color="secondary"
                        solo
                        :error-messages="getErrorForField('email')"
                        @focus="resetErrorForField('email')"
                        name="email">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                        :items="getAvaiableLanguage()"
                        :placeholder="$vuetify.t('$vuetify.Account.languagePlaceholder')"
                        color="secondary"
                        background-color="primary"
                        name="language"
                        solo
                        :error-messages="getErrorForField('language')"
                        label="Box style"
                        v-model="user.language"
                        @change="changeCurrentLanguage()"
                        @focus="resetErrorForField('language')"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>

            <v-flex xs12>
              <v-btn block class="eco-button"
                     color="button-light"
                     type="submit"
                     large
                     @click.prevent="executeUserUpdate()">
                {{
                  $vuetify.t('$vuetify.Account.update') |
                      uppercase
                }}

              </v-btn>
            </v-flex>


          </v-layout>
        </v-container>
      </form-with-base-message>
    </v-flex>

  </v-layout>


</template>

<script>

import FormWithBaseMessage from "../components/FormWithBaseMessage"
import FormValidation from "../mixins/formValidation"
import AvailableLanguage from "../mixins/availableLanguage"
import AvailableCountries from "../mixins/availableCoutries"

export default {
  name: 'Account',
  data() {
    return {
      user: {
        firstname: "",
        lastname: "",
        telephone1: "",
        language: "IT",
        email: "",
        badge: "",
        residenceAddress: "",
        residenceNumber: "",
        residenceCap: "",
        residenceCity: "",
        residenceDistrict: "",
        residenceCountry: "",
        nationalIdentificationNumber: ""
      },
      successMessage: {},
      loadingUpdateUser: false
    }
  },
  mixins: [FormValidation, AvailableLanguage, AvailableCountries],
  apollo: {
    user: {
      client: "clientPrivate",
      query: require("../graphql/queries/currentUserFull.gql")

    }
  },
  methods: {
    executeUserUpdate() {
      this.loadingUpdateUser = true
      const UPDATE_MUTATION = require("../graphql/mutations/updateUser.gql")
      let attributes = this.user
      delete attributes["__typename"]
      delete attributes["balance"]

      this.$apollo.mutate({
        client: "clientPrivate",
        // Query
        mutation: UPDATE_MUTATION,
        // Parameters
        variables: {
          attributes
        },

      }).then((result) => {
        this.loadingUpdateUser = false

        result = result.data.userUpdate

        if (result._response.result) {
          this.$vuetify.lang.current = result.result.language
          this.successMessage = {
            title: this.$vuetify.t("$vuetify.Account.updateSuccesfullyTitle"),
            text: this.$vuetify.t("$vuetify.Account.updateSuccesfully")
          }

          setTimeout(() => {
            this.$router.push({path: "/"})
          }, 3200)


        } else {

          this.errors = this.collectErrors(result._response.errors, "Account")
        }


      }).catch((error) => {
        console.log(error)

        //TODO implementare default error catcher
        // Error
        //console.error(error)

      })


    },
    changeCurrentLanguage() {
      this.setGlobalCurrentLanguage(this.user.language);
    }
  },
  components: {
    FormWithBaseMessage
  }

}
</script>
